import { render, staticRenderFns } from "./CostsItem.vue?vue&type=template&id=63f6e4e5&scoped=true&functional=true"
import script from "./CostsItem.vue?vue&type=script&lang=js"
export * from "./CostsItem.vue?vue&type=script&lang=js"
import style0 from "./CostsItem.vue?vue&type=style&index=0&id=63f6e4e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "63f6e4e5",
  null
  
)

export default component.exports